(function () {
  var PRODUCT_SECTION_CLASS = 'shopify-section--main-product';
  var GALLERY_SELECTOR = '.product-gallery';
  var IS_PDP = !!document.querySelector('.' + PRODUCT_SECTION_CLASS);

  // One shared cache for both PDP + cards
  var productCache = Object.create(null);

  /* ===================== Shared helpers ===================== */
  function fetchProduct(handle, signal) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin', signal: signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) productCache[handle] = j; return j; });
  }

  function preload(url) {
    if (!url) return Promise.resolve();
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
    if (img.decode) return img.decode().catch(function () {});
    return new Promise(function (resolve) { img.onload = img.onerror = resolve; });
  }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  /* ===================== PDP (AJAX) ===================== */
  if (IS_PDP) {
    var pv = {}; // PDP-only helpers

    pv.getMainSectionEl = function(){ return document.querySelector('.' + PRODUCT_SECTION_CLASS); };
    pv.getMainSectionId = function(){ var el = pv.getMainSectionEl(); return el ? el.id.replace(/^shopify-section-/,'') : null; };
    pv.getWrapperSectionIdFor = function(el){ var s = el && el.closest('.shopify-section'); return s ? s.id.replace(/^shopify-section-/,'') : null; };
    pv.urlWithSections = function(url, ids){ var u = new URL(url, window.location.origin); u.searchParams.set('sections', ids.join(',')); return u.toString(); };

    pv.setLoading = function(on){
      var secs = [];
      var main = pv.getMainSectionEl(); if (main) secs.push(main);
      document.querySelectorAll('[data-product-refresh-images]').forEach(function(n){ var s=n.closest('.shopify-section'); if (s) secs.push(s); });
      secs.forEach(function(sec){ sec.classList.toggle('is-loading', !!on); sec.setAttribute('aria-busy', on ? 'true':'false'); });
    };

    pv.getVariantPicker = function(){ var sec=pv.getMainSectionEl(); return sec && sec.querySelector('variant-picker'); };
    pv.getHandle = function(){
      var vp = pv.getVariantPicker();
      if (vp && vp.getAttribute('handle')) return vp.getAttribute('handle');
      var m = location.pathname.match(/\/products\/([^\/\?]+)/);
      return m ? m[1] : null;
    };

    pv.getSelectedSize = function(){
      var sec = pv.getMainSectionEl(); if(!sec) return null;
      var sets = sec.querySelectorAll('fieldset.variant-picker__option, .variant-picker__option');
      for (var i=0;i<sets.length;i++){
        var fs = sets[i];
        var legend = fs.querySelector('legend, .variant-picker__option-info legend');
        var label = (legend && legend.textContent || '').trim().toLowerCase();
        if (label === 'size') {
          var checked = fs.querySelector('input[type="radio"]:checked');
          if (checked && checked.value) return checked.value;
        }
      }
      var any = sec.querySelector('input[type="radio"][name^="option"]:checked');
      return any ? any.value : null;
    };

    pv.getSelectedOptions = function(){
      var sec = pv.getMainSectionEl(); if(!sec) return [];
      var out = []; var i = 1, input;
      while ((input = sec.querySelector('input[type="radio"][name="option'+i+'"]:checked'))) {
        out.push(input.value);
        i++;
      }
      return out;
    };

    pv.selectVariantByOptions = function(options){
      var sec = pv.getMainSectionEl(); if (!sec) return;
      for (var i = 0; i < options.length; i++) {
        var val = options[i];
        var input = sec.querySelector('input[type="radio"][name="option' + (i+1) + '"][value="' + CSS.escape(val) + '"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      setTimeout(function(){ pv.ensureCorrectVariantIdSync() || pv.ensureCorrectVariantIdAsync(); }, 0);
    };

    pv.setAtcStateFromVariant = function(variant){
      var sec = pv.getMainSectionEl(); if (!sec || !variant) return;
      var btn = sec.querySelector('form.shopify-product-form button[type="submit"]');
      if (!btn) return;
      if (variant.available) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-text-atc') || 'Add to Cart';
      } else {
        btn.disabled = true;
        if (!btn.hasAttribute('data-text-atc')) btn.setAttribute('data-text-atc', btn.textContent.trim());
        btn.textContent = 'Sold out';
      }
    };

    // Product JSON helpers using shared cache
    pv.prefetchProductJsonForHandle = function(handle){
      return fetchProduct(handle);
    };
    pv.getVariantIdFromOptions = function(handle, selectedOptions){
      var json = productCache[handle];
      if (!json || !Array.isArray(json.variants)) return null;
      return (json.variants.find(function(v){
        if (!v || !Array.isArray(v.options)) return false;
        for (var i=0;i<selectedOptions.length;i++){
          if ((v.options[i] || '') !== (selectedOptions[i] || '')) return false;
        }
        return true;
      }) || {}).id || null;
    };
    pv.getProductJsonCurrent = function(){
      var h = pv.getHandle();
      return h ? productCache[h] || null : null;
    };
    pv.getSizeOptionIndex = function(json){
      if (!json || !Array.isArray(json.options)) return 0;
      var idx = json.options.findIndex(function(n){ return String(n || '').toLowerCase() === 'size'; });
      return idx === -1 ? 0 : idx;
    };

    pv.forceHiddenInputToVariant = function(variantId){
      var sec = pv.getMainSectionEl(); if (!sec || !variantId) return;
      sec.querySelectorAll('form.shopify-product-form input[name="id"]').forEach(function(input){
        if (String(input.value) !== String(variantId)) input.value = variantId;
      });
    };
    pv.getCurrentVariantIdFromHidden = function(){
      var sec = pv.getMainSectionEl(); if (!sec) return null;
      var input = sec.querySelector('form.shopify-product-form input[name="id"]');
      return input && input.value ? input.value : null;
    };
    pv.updateUrlWithVariant = function(variantId){
      if (!variantId) return;
      var u = new URL(window.location.href);
      u.searchParams.set('variant', variantId);
      history.replaceState(Object.assign({}, history.state || {}, {variantId:variantId, ajaxProduct:true}), '', u.pathname + u.search);
    };
    pv.ensureCorrectVariantIdSync = function(){
      var handle = pv.getHandle();
      var opts = pv.getSelectedOptions();
      if (!handle || !opts.length) return null;
      var vid = pv.getVariantIdFromOptions(handle, opts);
      if (vid) {
        pv.forceHiddenInputToVariant(vid);
        pv.updateUrlWithVariant(vid);
      }
      return vid;
    };
    pv.ensureCorrectVariantIdAsync = async function(){
      var handle = pv.getHandle();
      var opts = pv.getSelectedOptions();
      if (!handle || !opts.length) return null;
      await pv.prefetchProductJsonForHandle(handle);
      var vid = pv.getVariantIdFromOptions(handle, opts);
      if (vid) {
        pv.forceHiddenInputToVariant(vid);
        pv.updateUrlWithVariant(vid);
      }
      return vid;
    };
    pv.afterVariantSynced = function(cb){
      var vid = pv.ensureCorrectVariantIdSync();
      if (vid) { cb(vid); return; }
      pv.ensureCorrectVariantIdAsync().then(function(vid2){ cb(vid2); });
    };

    pv.invalidateWairPopup = function(){
      document.querySelectorAll('.wair-modal, .wair-widget-modal, [data-wair-modal], .wair-overlay, iframe[src*="wair"]').forEach(function(node){
        if (node.closest('[data-wair-preserve]')) return;
        node.remove();
      });
    };
    pv.refreshWairButton = function(){
      var wrap = document.querySelector('[data-wair-preserve]');
      if (!wrap) return;
      var btn = wrap.querySelector('button, a, [role="button"]');
      if (!btn) return;
      var vid = pv.getCurrentVariantIdFromHidden();
      if (vid) {
        wrap.setAttribute('data-variant-id', vid);
        btn.setAttribute('data-variant-id', vid);
      }
      var tick = String(Date.now());
      wrap.setAttribute('data-wair-tick', tick);
      btn.setAttribute('data-wair-tick', tick);
    };
    pv.notifyWair = function(){
      try {
        if (window.WAIR && typeof window.WAIR.refresh === 'function') window.WAIR.refresh();
        else document.dispatchEvent(new Event('wair:refresh'));
      } catch(e){}
    };

    pv.normalizePreservedAccordions = function(root){
      root.querySelectorAll('details[is="accordion-disclosure"]').forEach(function(d){
        d.classList.remove('auto-open');
        d.style.height = null; d.style.overflow = null;
        d.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
        var c = d.querySelector(':scope > .accordion__content');
        if (c) { c.style.opacity = null; c.style.transform = null; }
      });
    };
    pv.replaceSectionHtml = function(sectionId, html){
      var current = document.querySelector('#shopify-section-' + sectionId);
      if (!current) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var incoming = tmp.querySelector('#shopify-section-' + sectionId);
      if (!incoming) return;
      if (current.classList.contains(PRODUCT_SECTION_CLASS)) {
        ['.accordion-group[data-preserve]','[data-wair-preserve]'].forEach(function (sel) {
          var oldList = current.querySelectorAll(sel);
          var newList = incoming.querySelectorAll(sel);
          for (var i = 0; i < newList.length; i++) {
            var keep = oldList[i], target = newList[i];
            if (keep && target) {
              pv.normalizePreservedAccordions(keep);
              target.replaceWith(keep);
            }
          }
        });
      }
      current.replaceWith(incoming);
    };
    pv.replaceSectionImagesOnly = function(sectionId, html){
      var currentRoot = document.querySelector('#shopify-section-' + sectionId);
      if (!currentRoot) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var incomingRoot = tmp.querySelector('#shopify-section-' + sectionId);
      if (!incomingRoot) return;

      var inImgs  = incomingRoot.querySelectorAll('img.Callout__Image');
      var curImgs = currentRoot.querySelectorAll('img.Callout__Image');
      var count = Math.min(inImgs.length, curImgs.length);
      for (var i=0;i<count;i++){
        var src = inImgs[i], dst = curImgs[i];
        ['data-src','data-srcset','data-sizes','data-widths','data-optimumx','alt'].forEach(function (name) {
          var val = src.getAttribute(name);
          if (val !== null) dst.setAttribute(name, val); else dst.removeAttribute(name);
        });
        dst.removeAttribute('src'); dst.removeAttribute('srcset');
        dst.classList.add('lazyload','lazyautosizes','Image--lazyLoad');
        dst.classList.remove('is-loaded','Image--lazyLoaded');
        if (window.lazySizes && lazySizes.loader) {
          lazySizes.loader.unveil(dst);
        }
      }
    };

    pv.hydrateLazyImgs = function(root){
      if (!root) return;
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.getAttribute('src') && img.dataset && img.dataset.src && img.dataset.src.indexOf('{width}') === -1) {
          img.setAttribute('src', img.dataset.src);
        }
        if (!img.getAttribute('srcset') && img.dataset && img.dataset.srcset && img.dataset.srcset.indexOf('{width}') === -1) {
          img.setAttribute('srcset', img.dataset.srcset);
        }
        if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
        img.addEventListener('load', function(){ img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function(){ img.classList.add('is-loaded'); }, { once: true });
      });
    };

    pv.reinitTheme = function(){
      var sec = pv.getMainSectionEl(); if (!sec) return;
      var id = sec.id.replace('shopify-section-','');

      try {
        document.dispatchEvent(new CustomEvent('shopify:section:unload', { detail: { sectionId: id } }));
        document.dispatchEvent(new CustomEvent('shopify:section:load',   { detail: { sectionId: id } }));
      } catch(e){}

      try {
        if (window.Prestige && typeof window.Prestige.init === 'function') window.Prestige.init();
        if (window.theme && typeof window.theme.initProduct === 'function') window.theme.initProduct(sec);
      } catch(e){}

      var pref = (typeof window.__preferredSizeOnce !== 'undefined' && window.__preferredSizeOnce) ? window.__preferredSizeOnce : pv.getSelectedSize();
      window.__preferredSizeOnce = null;
      if (pref) {
        var json = pv.getProductJsonCurrent();
        if (json) {
          var current = pv.getSelectedOptions();
          if (current.length) {
            var sizeIdx = pv.getSizeOptionIndex(json);
            var tryOptions = current.slice();
            tryOptions[sizeIdx] = pref;
            pv.selectVariantByOptions(tryOptions);
          }
        }
      } else {
        pv.ensureCorrectVariantIdSync() || pv.ensureCorrectVariantIdAsync();
      }

      pv.afterVariantSynced(function(){
        pv.invalidateWairPopup();
        pv.refreshWairButton();
        pv.notifyWair();
      });

      try { window.dispatchEvent(new Event('resize')); } catch(e){}
      if (window.lazySizes && lazySizes.autoSizer && lazySizes.autoSizer.checkElems) lazySizes.autoSizer.checkElems();

      var g = sec.querySelector(GALLERY_SELECTOR);
      var lead = g && g.querySelector('.product-gallery__media.is-initial img, .product-gallery__media.is-active img');
      if (lead && lead.complete && lead.naturalWidth > 0) lead.classList.add('is-loaded');

      document.dispatchEvent(new Event('okendo:refresh'));
    };

    pv.getRefreshPlan = function(){
      var plan = [];
      var mainId = pv.getMainSectionId();
      if (mainId) plan.push({ id: mainId, mode: 'full' });
      document.querySelectorAll('[data-product-refresh-images]').forEach(function (el) {
        var id = pv.getWrapperSectionIdFor(el);
        if (id && !plan.some(function(p){return p.id===id;})) plan.push({ id: id, mode: 'images' });
      });
      return plan;
    };

    pv.refreshTo = function(url){
      window.__preferredSizeOnce = pv.getSelectedSize();

      var handle = (url.pathname.match(/\/products\/([^\/\?]+)/) || [])[1];
      if (handle) fetchProduct(handle);

      var plan = pv.getRefreshPlan();
      if (!plan.length) { window.location.href = url; return; }

      var ids = plan.map(function(p){ return p.id; });
      var sectionsUrl = pv.urlWithSections(url, ids);

      pv.setLoading(true);
      fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (r){ return r.json(); })
        .then(function (json){
          plan.forEach(function (p){
            var html = json[p.id]; if (!html) return;
            if (p.mode === 'images') pv.replaceSectionImagesOnly(p.id, html);
            else pv.replaceSectionHtml(p.id, html);
          });

          history.replaceState({ ajaxProduct:true, sectionIds: ids }, '', url.pathname + url.search);

          pv.hydrateLazyImgs(document);
          pv.reinitTheme();
        })
        .catch(function(){ window.location.href = url; })
        .finally(function(){ pv.setLoading(false); });
    };

    // PDP-only listeners
    document.addEventListener('click', function onPdpClick(e){
      var a = e.target.closest('a');
      if (!a) return;
      if (!a.closest('.variant-picker__option-values')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;

      var href = a.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;

      if (!a.closest('.' + PRODUCT_SECTION_CLASS)) return;

      e.preventDefault();
      pv.refreshTo(new URL(href, window.location.origin));
    });

    window.addEventListener('popstate', function onPdpPopState(e){
      if (!e.state || !e.state.ajaxProduct) return;

      window.__preferredSizeOnce = pv.getSelectedSize();

      var plan = pv.getRefreshPlan();
      if (!plan.length) return;
      var ids = plan.map(function(p){ return p.id; });
      var sectionsUrl = pv.urlWithSections(window.location.href, ids);

      pv.setLoading(true);
      fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (r){ return r.json(); })
        .then(function (json){
          plan.forEach(function (p){
            var html = json[p.id]; if (!html) return;
            if (p.mode === 'images') pv.replaceSectionImagesOnly(p.id, html);
            else pv.replaceSectionHtml(p.id, html);
          });
          pv.hydrateLazyImgs(document);
          pv.reinitTheme();
        })
        .finally(function(){ pv.setLoading(false); });
    });

    document.addEventListener('DOMContentLoaded', function(){
      var h = pv.getHandle(); if (h) fetchProduct(h);
      pv.hydrateLazyImgs(document);
      pv.reinitTheme();
    });
  }

  /* ===================== Collection product cards (no rail, just preload) ===================== */
(function initCollectionCards(){
  var PREFETCH = {
    enable: true,
    maxPerCard: 8,
    prefetchSecondary: true,
    viewportLookahead: 1.2,
    maxConcurrent: 4
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-card-swatches]').forEach(function (root) {
      var more = root.querySelector('[data-swatch-more]');
      var selected = root.querySelector('a.color-swatch.is-selected, a.thumbnail-swatch.is-selected');
      if (more && selected) more.href = selected.href;
    });
  });

  var inflight = 0;
  var queue = [];

  function schedule(task){
    queue.push(task);
    drain();
  }
  function drain(){
    if (inflight >= PREFETCH.maxConcurrent || !queue.length) return;
    inflight++;
    var fn = queue.shift();
    var done = function(){ inflight--; drain(); };
    try { var p = fn(); if (p && p.then) p.finally(done); else done(); } catch(e){ done(); }
  }

  function withinPdp(el){ return !!el.closest('.shopify-section--main-product'); }
  function card(el){ return el.closest('product-card.product-card'); }
  function leadImg(c){ return c ? c.querySelector('img.product-card__image--primary') : null; }
  function hoverImg(c){ return c ? c.querySelector('img.product-card__image--secondary') : null; }
  function mediaLink(c){ return c ? c.querySelector('a.product-card__media') : null; }
  function titleLink(c){ return c ? c.querySelector('a.product-title') : null; }
  function colorLink(c){ return c ? c.querySelector('a.product-color') : null; }   // NEW
  function setImg(el, src){ if (!el || !src) return; el.removeAttribute('srcset'); el.src = src; }
  function handleFromHref(href){ var m=(href||'').match(/\/products\/([^\/\?]+)/); return m?m[1]:null; }

  // Prefer label from swatch DOM; fallback to product JSON later
  function swatchLabel(a){
    var s = (a.getAttribute('aria-label') || '').trim();
    if (s) return s;
    var sr = a.querySelector('.sr-only');
    return sr ? sr.textContent.trim() : '';
  }

  // Click: prevent nav, swap images, update color line only
  document.addEventListener('click', function(e){
    var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
    if (!a) return;
    if (withinPdp(a)) return;

    var c = card(a); if (!c) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

    var href = a.getAttribute('href');
    var group = a.closest('.variant-picker__color-swatches');
    var more = group && group.querySelector('[data-swatch-more]');
    if (more) more.setAttribute('href', href);

    var handle = handleFromHref(href);
    if (!handle) return;

    // Update links
    var mA = mediaLink(c); if (mA) mA.href = href;
    var tA = titleLink(c); if (tA) tA.href = href;          // keep title text as-is
    var cA = colorLink(c);                                   // color line link

    // Set color line from swatch label immediately
    var label = swatchLabel(a);
    if (cA) {
      if (label) cA.textContent = label;
      cA.href = href;
    }

    // Toggle selection UI
    var wrap = a.closest('.variant-picker__color-swatches');
    if (wrap) {
      wrap.querySelectorAll('a.color-swatch, a.thumbnail-swatch').forEach(function(n){ n.classList.remove('is-selected'); });
      a.classList.add('is-selected');
    }

    // Cancel any in-flight for this card
    if (c.__swatchCtrl) try { c.__swatchCtrl.abort(); } catch(_){}
    var ctrl = new AbortController(); c.__swatchCtrl = ctrl;
    c.__swatchToken = (c.__swatchToken || 0) + 1; var token = c.__swatchToken;

    // Fetch JSON → swap images; also use it as label fallback if needed
    fetch('/products/' + handle + '.js', { credentials:'same-origin', signal:ctrl.signal })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        if (!j || token !== c.__swatchToken) return;
        var imgs = j.images || [];
        var primary = imgs[0] || '';
        var secondary = imgs[1] || primary;

        // Fallback color label from product title if swatch had none
        if (cA && !label) {
          var parts = String(j.title||'').split(' - ');
          var fallbackColor = parts.length > 1 ? parts.slice(1).join(' - ').trim() : '';
          if (fallbackColor) cA.textContent = fallbackColor;
        }

        var p1 = primary ? new Promise(function(res){ var i=new Image(); i.onload=i.onerror=res; i.src=primary; }) : Promise.resolve();
        var p2 = secondary ? new Promise(function(res){ var i=new Image(); i.onload=i.onerror=res; i.src=secondary; }) : Promise.resolve();

        return Promise.allSettled([p1, p2]).then(function(){
          if (token !== c.__swatchToken) return;
          setImg(leadImg(c), primary);
          setImg(hoverImg(c), secondary);
          c.dataset.activeHandle = handle;
        });
      })
      .catch(function(){ /* swallow */ });
  }, true);

  // Keyboard a11y
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
    if (!a || withinPdp(a)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); a.click();
  }, true);

  // Hover prefetch (unchanged)
  document.addEventListener('mouseover', function(e){
    var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
    if (!a || withinPdp(a)) return;
    var handle = handleFromHref(a.getAttribute('href')); if (!handle) return;

    schedule(function(){
      return fetch('/products/' + handle + '.js', { credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          if (!j) return;
          var imgs = j.images || [];
          var p = imgs[0] || '';
          var s = imgs[1] || p;
          var tasks = [];
          if (p) tasks.push(new Promise(function(res){ var i=new Image(); i.onload=i.onerror=res; i.src=p; }));
          if (PREFETCH.prefetchSecondary && s) tasks.push(new Promise(function(res){ var i=new Image(); i.onload=i.onerror=res; i.src=s; }));
          return Promise.allSettled(tasks);
        });
    });
  }, { passive: true });

    // Viewport prefetch: warm a handful of swatches for cards as they approach view
    if ('IntersectionObserver' in window && PREFETCH.enable) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting && entry.intersectionRatio === 0) return;
          var c = entry.target;
          var wrap = c.querySelector('[data-card-swatches]') || c;
          var links = wrap.querySelectorAll('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
          var limit = Math.min(links.length, PREFETCH.maxPerCard);

          for (var i=0;i<limit;i++){
            (function(a){
              var h = handleFromHref(a.getAttribute('href')); if (!h) return;
              schedule(function(){
                return fetchProduct(h).then(function(j){
                  if (!j) return;
                  var imgs = j.images || [];
                  var p = imgs[0] || '';
                  var s = imgs[1] || p;
                  return PREFETCH.prefetchSecondary
                    ? Promise.allSettled([preload(p), preload(s)])
                    : preload(p);
                });
              });
            })(links[i]);
          }

          io.unobserve(c);
        });
      }, { root: null, rootMargin: Math.round((PREFETCH.viewportLookahead - 1) * 100) + '% 0px', threshold: [0, 0.01] });

      document.querySelectorAll('product-card.product-card').forEach(function(pc){ io.observe(pc); });
    }

    // Dynamic swatch count based on container width
    (function initDynamicSwatchCount() {
      var MOBILE_BREAKPOINT = 650; // Adjust to match your theme's breakpoint

      function isMobile() {
        return window.innerWidth < MOBILE_BREAKPOINT;
      }

      function updateSwatchCount(container) {
        if (!container) return;
        
        var swatches = Array.from(container.querySelectorAll('a.color-swatch, a.thumbnail-swatch'));
        var moreBtn = container.querySelector('[data-swatch-more]');
        
        if (!swatches.length) return;

        var total = parseInt(container.getAttribute('data-total-colors')) || swatches.length;
        var maxMobile = parseInt(container.getAttribute('data-max-mobile')) || 5;
        var maxDesktop = parseInt(container.getAttribute('data-max-desktop')) || 9;
        var mobile = isMobile();
        var maxVisible = mobile ? maxMobile : maxDesktop;
        
        // Show all swatches initially
        swatches.forEach(function(s) { 
          s.style.display = ''; 
          s.classList.remove('hide-mobile');
        });
        if (moreBtn) moreBtn.style.display = '';
        
        // Force layout
        container.offsetHeight;
        
        var visible = 0;
        
        // On mobile, enforce strict limit from data attribute
        if (mobile) {
          for (var i = 0; i < swatches.length; i++) {
            if (i < maxVisible) {
              visible++;
            } else {
              swatches[i].style.display = 'none';
            }
          }
        } else {
          // On desktop, check for wrapping
          var firstRowTop = swatches[0].offsetTop;
          
          for (var i = 0; i < swatches.length; i++) {
            if (swatches[i].offsetTop === firstRowTop && i < maxVisible) {
              visible++;
            } else {
              // Hide this and all following swatches
              for (var j = i; j < swatches.length; j++) {
                swatches[j].style.display = 'none';
              }
              break;
            }
          }
        }

        // Update +N button
        if (moreBtn) {
          var remaining = total - visible;
          if (remaining > 0) {
            moreBtn.style.display = '';
            var countSpan = moreBtn.querySelector('[data-remaining-count]');
            if (countSpan) countSpan.textContent = remaining;
          } else {
            moreBtn.style.display = 'none';
          }
        }
      }

      function updateAllCards() {
        document.querySelectorAll('.variant-picker__color-swatches').forEach(updateSwatchCount);
      }

      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(updateAllCards, 300);
      });

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateAllCards, 100);
      });
    })();
  })();
})();